const fullAppRoles = ['owner', 'admin', 'staff'];

export const userHasFullAppRole = (roles) => {
  if (!roles) {
    return false;
  }
  return fullAppRoles.some((role) => roles.indexOf(role) > -1);
};
